<script>
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';
  import LoginBackground from './LoginBackground.svelte';
  import { loginStore } from './loginStore';
  import { loggedInUser } from '../../Store/user-store';
  import { tv2Logo } from './Icons';
  import { firebaseApp } from '../../Store/firebase-store';
  import { loginWithCustomToken } from '../../Api/api';
  import Spinner from '../Common/Spinner.svelte';
  import { channel } from '../Chat/chat-store';

  const dispatch = createEventDispatcher();

  export let basePath = '';

  let showSpinner = false;

  $: news = $channel && $channel.category === 'news';
  $: sport = $channel && $channel.category === 'sport';
  $: entertainment = $channel && $channel.category === 'entertainment';
  $: spinnerColor = $channel && (news || entertainment || sport) ? '#fafafa' : '#222222';

  async function loginWithSumo(username, password) {
    const body = JSON.stringify({ username, password });
    const response = await fetch(`${basePath}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: body,
    });

    const data = await response.json();
    return { response, data };
  }

  async function login() {
    showSpinner = true;
    try {
      const { response, data } = await loginWithSumo($loginStore.username, $loginStore.password);

      if (!response.ok) {
        showSpinner = false;
        loginStore.setErrorMessage(data.error);
      } else {
        const { user } = await loginWithCustomToken(data.firebaseToken, $firebaseApp);

        loggedInUser.set(user);

        $loginStore.chatAlias = user.displayName ? user.displayName : data.profile.displayName;

        showSpinner = false;
        dispatch('user-logged-in');
      }
    } catch (err) {
      showSpinner = false;
      loginStore.setErrorMessage(err);
    }
  }
</script>

<div class="sumo-login-container" in:slide class:news class:sport class:entertainment>
  <LoginBackground
    icon={tv2Logo}
    height="212"
    iconMarginTop="-92"
    backgroundColor="#110118"
    on:close={() => loginStore.close()}
  />
  <div class="content">
    {#if showSpinner}
      <div class="spinner">
        <Spinner color={spinnerColor} />
      </div>
    {:else}
      <h1 class="sumo-user-label">
        Logg inn med din <span class="helper-nowrap">TV 2 Play</span> bruker
      </h1>
      <div id="login-form" class="login-form">
        <input
          type="email"
          id="username"
          name="username"
          placeholder="E-post"
          bind:value={$loginStore.username}
          on:change={() => loginStore.setErrorMessage('')}
        />
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Passord"
          bind:value={$loginStore.password}
          on:change={() => loginStore.setErrorMessage('')}
        />
        <button on:click={login} class="loginBtn">Logg inn</button>
        <div class="error">{$loginStore.errorMessage}</div>
      </div>
      <div class="external-hrefs">
        <div class="external-href">
          <a class="href" href="https://play.tv2.no/tac" target="_blank"> Brukervilkår </a>
        </div>
        <div class="external-href">
          <a class="href" href="https://play.tv2.no/ny-bruker"> Glemt passord? </a>
        </div>
        <div class="external-href">
          <span>Har du ikke bruker?</span>
          <a class="href" href="https://play.tv2.no/ny-bruker"> Registrer deg her </a>
        </div>
      </div>
    {/if}
  </div>
</div>

<style src="./sumo.scss"></style>
